import React, { useEffect, useState, useContext } from "react";
import styles from './style'
import { useTheme } from '@mui/styles'
import { Container, Grid, Typography, Dialog } from '@mui/material'
import { Button } from '@alquiler-argentina/aa-componentes'
import { CognitoUserSession, CognitoIdToken, CognitoAccessToken, CognitoUser, CognitoRefreshToken, CookieStorage } from "amazon-cognito-identity-js";
import userPool from '../UserPool';
import axios from "axios";
import isMobile from 'ismobilejs';
import ModalCloseIcon from '../ModalCloseIcon';
import ContextUser from '../ContextUser/Context';
import AACargando from '../../Commons/AACargando';
import * as Sentry from '@sentry/react';

export default function SuccessRegister(props) {
    const theme = useTheme()
    const classes = styles(theme);
    const [loader, setLoader] = useState(true);
    const [cmIntegrated, setCmIntegrated] = useState('');
    const [anfitrion, setAnfitrion] = useState(props.anfitrion);
    const [userData, setUserData] = useState();
    const [tipo, setTipo] = useState(1);
    const redirect = localStorage.getItem("redirect");
    const titleAnfitrion = '¿Cómo queres continuar?'
    const titleHuesped = '¡Te damos la bienvenida!'
    const subtitleHuesped = 'Disfrutá de viajar con Alquiler Argentina, descubrí alojamientos en todo el país para hospedarte en tu próximo destino.'

    const {	getIdentityByUsername, state, getSession } = useContext(ContextUser)

    const isApp = window.location.href.includes("app");
    const esSiro = localStorage.getItem('esTroya');
    const cm = localStorage.getItem('cmIntegrated');

    const createAnfitrionPublicar = window.opener && window.opener.location.pathname == '/publicar.html' ;
    useEffect(() => {
        if (!state.email) {
            getSession();
        }
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        if(cm && cm !== 'null'){
            setCmIntegrated(cm);
            localStorage.removeItem('cmIntegrated');
        }
        if(code && code !== ''){
            const formData = new FormData();
            formData.append('grant_type', 'authorization_code');
            formData.append('code', code);
            formData.append('client_id', process.env.MIX_CLIENT_ID_COGNITO);
            formData.append('redirect_uri', `${ !isApp ? process.env.MIX_DOMINIO_WEB : process.env.MIX_DOMINIO_APP }/success-register`);
            axios({
                method: 'post',
                url: `${process.env.MIX_DOMAIN_COGNITO}/oauth2/token`,
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: new URLSearchParams(formData).toString()
              })
              .then(response => {
               signInSessionSocialLogin(response.data.id_token, response.data.access_token, response.data.refresh_token);
               const cognitoIdToken = new CognitoIdToken({
                IdToken: response.data.id_token,
            });
            let picture = cognitoIdToken.payload.picture;
            const identity = cognitoIdToken.payload.identities.length ? cognitoIdToken.payload.identities[0].providerName : ''
            
            if(identity == 'Facebook'){
                const parsePicture = JSON.parse(cognitoIdToken.payload.picture)
                picture = parsePicture.data.url
            } 
            const dataUser = {
                name: cognitoIdToken.payload.name,
                picture: picture,
                email: cognitoIdToken.payload.email,
                identity: cognitoIdToken.payload.identities.length ? cognitoIdToken.payload.identities[0].providerName : ''
            }
            setUserData(dataUser);
            axios
            .get(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/?email=${dataUser.email}`)
            .then((result) => {
                // si viene data y la identity es igual a 1 (Login) actualizo los datos del usuario
                if(result.data.email && result.data.identity == 1){
                    setTipo(result.data.tipo)
                    updateDataUser(dataUser, result.data)
                } else if(!result.data.email) {
                    saveDataUser(dataUser)
                } else {
                    setTipo(result.data.tipo)
                    checkViewShow(result.data)
                }
            })
              })
              .catch(error => {
                console.error(error);
              });
        } else {
            setLoader(false)
        }
    }, [])
    const onClickIngresarPanel = () =>{
        // si viene por login normal usa el "state.tipo" y si viene por google o face comprueba con el "tipo"
        if(state.tipo == 2 || tipo == 2){
            if(window.opener){
                // si se loguea con google o facebook cierro el popup y redirecciono al pdc
                window.opener.location.replace(process.env.MIX_URL_PDC_LITE);
                window.close();
            } else {
                window.location.href= process.env.MIX_URL_PDC_LITE;
            }
        } else if(state.tipo == 3 || tipo == 3){
            if(window.opener){
                window.opener.location.replace(process.env.MIX_URL_PDC);
                window.close();
            } else {
                window.location.href= process.env.MIX_URL_PDC;
            }
        }
    }

    const checkViewShow = (data) => {
     
        if (state.tipo == 1 && state.identity != 1 && !createAnfitrionPublicar ){   // si el usuario es tipo turista y se logea con social login, se abre una ventana y refrescamos su location
            initSocialLogin()
        } else if(data.tipo == 1 && data.identity == 1){  // si el usuario es tipo turista y no se logea con social login, solamente refrescamos su location
            window.location.href= "/";
        } else if( data.tipo != 1 || props.createAnfitrion || createAnfitrionPublicar ){   // si el usuario es tipo anfitrión y seteamos el title, el subtitle y el botón de ingresar al panel 
            setAnfitrion(true)
        } 
        setLoader(false)
    }
    const initSocialLogin = () => {
        setLoader(true);
        if(location.pathname == '/login' || !window.opener && !props.modalOpen){
            window.location.href = process.env.MIX_DOMINIO_WEB;	
        } else if (window.opener) {
                window.opener.location.reload();
                return window.close();
         } else {
               props.onCloseLoginModal()
               location.reload();
        } 
    }

    const updateDataUser = (dataUser, dataDb) => {

        const identityNumber = getIdentityByUsername(dataUser.identity)
        return axios.put(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/`, {
            identity: identityNumber,
            picture: dataUser.picture ? dataUser.picture : '', 
            name: dataUser.name ? dataUser.name : '', 
            updated_password: 1,
            email: dataUser.email,
        })
        .then(() => {
            checkViewShow(dataDb);
        })
    }

    const saveDataUser = (dataUser) => {
        const identityNumber = getIdentityByUsername(dataUser.identity)
        return axios.post(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/`, {
            email: dataUser.email, 
            tipo: 1, 
            identity: identityNumber,
            picture: dataUser.picture ? dataUser.picture : '', 
            name: dataUser.name ? dataUser.name : '', 
            updated_password: 1,
        })
        .then((result) => {
            axios.post(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/verificar/usuarios`, {email : dataUser.email});
            setLoader(false)
        })
    }

    const signInSessionSocialLogin = (idToken, accessToken, refreshToken) => {
        
        const cognitoIdToken = new CognitoIdToken({
            IdToken: idToken,
        });
        const cognitoAccessToken = new CognitoAccessToken({
            AccessToken: accessToken,
        });
        const cognitoRefreshToken = new CognitoRefreshToken({
            RefreshToken: refreshToken,
        });
        const username = cognitoIdToken.payload.email;
        const user = new CognitoUser({
            Username: username,
            Pool: userPool,
            Storage: new CookieStorage({domain: process.env.MIX_COOKIE_DOMAIN})
        });
        user.setSignInUserSession(new CognitoUserSession({
            AccessToken: cognitoAccessToken,
            IdToken: cognitoIdToken,
            RefreshToken: cognitoRefreshToken,
        }));
    }

    const handleClose = () =>{
        props.onCloseLoginModal()
        location.reload();
    }

    const onClickContinuar = () => { 
        {anfitrion && props.modalOpen ? location.reload() : initSocialLogin()}
    } 

    const publicarAnfitrion = () => {
        if(userData){
            axios
            .get(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/?email=${userData.email}`)
            .then((result) => {
                // si viene data y la identity es igual a 1 (Login) actualizo los datos del usuario
                if(result.data.email && result.data.tipo == 1){
                    axios
                    .put(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/`, {
                            tipo: 2,
                            identity: userData.identity === 'Google' ? 2 : 3,
                            email: userData.email,
                            updated_password: 1
                    }).then(() => {
                        const cantUnidades = 1
                        const link = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&e="+userData.email+"&cant_unidades="+cantUnidades+(window.g && window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g && window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : ""+(cmIntegrated && cmIntegrated !== '' ? `&cm_integrated=${cmIntegrated}` : ''));
                        const linkTroya = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&es_troya=1&e="+userData.email+(window.g && window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g && window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : ""+(cmIntegrated && cmIntegrated !== '' ? `&cm_integrated=${cmIntegrated}` : ''))
                        if(window.opener){
                            window.opener.location.href = props.esTroya || esSiro == 'true' ? linkTroya : link;
                            if (window.opener.progressWindow){
                                window.opener.progressWindow.close();
                            }
                            window.close();   
                        } else {
                            window.location.href = props.esTroya || esSiro == 'true' ? linkTroya : link;	
                        }
                    })
                } else {
                    const cantUnidades = 1
                    const link = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&e="+userData.email+"&cant_unidades="+cantUnidades+(window.g && window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g && window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : ""+(cmIntegrated && cmIntegrated !== '' ? `&cm_integrated=${cmIntegrated}` : ''));
                    const linkTroya = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&es_troya=1&e="+userData.email+(window.g && window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g && window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : ""+(cmIntegrated && cmIntegrated !== '' ? `&cm_integrated=${cmIntegrated}` : ''));
                    if(window.opener){
                        window.opener.location.href = props.esTroya || esSiro == 'true' ? linkTroya : link;
                        if (window.opener.progressWindow){
                            window.opener.progressWindow.close();
                        }
                        window.close();   
                    } else {
                        window.location.href = props.esTroya || esSiro == 'true' ? linkTroya : link;	
                    }
                }
            })
        }
        if(props.email){
            if(props.tipo == 1){
                axios
                .put(`${process.env.MIX_URL_API}${process.env.MIX_API_VERSION}/login/usuarios/`, {
                        tipo: 2,
                        identity: userData?.identity || state.identity,
                        email: userData?.email || props.email,
                        updated_password: 1
                }).then(() => {
                    const cantUnidades = 1
                    const link = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&e="+props.email+"&cant_unidades="+cantUnidades+(window.g && window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g && window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : ""+(cmIntegrated && cmIntegrated !== '' ? `&cm_integrated=${cmIntegrated}` : ''));
                    const linkTroya = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&es_troya=1&e="+props.email+(window.g && window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g && window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : ""+(cmIntegrated && cmIntegrated !== '' ? `&cm_integrated=${cmIntegrated}` : ''));
                    if(window.opener){
                        window.opener.location.href = props.esTroya || esSiro == 'true' ? linkTroya : link;
                        if (window.opener.progressWindow){
                            window.opener.progressWindow.close();
                        }
                        window.close();   
                    } else {
                        window.location.href = props.esTroya || esSiro == 'true' ? linkTroya : link;	
                    }
                })
            } else {
                const cantUnidades = 1
                const link = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&e="+props.email+"&cant_unidades="+cantUnidades+(window.g && window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g && window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : ""+(cmIntegrated && cmIntegrated !== '' ? `&cm_integrated=${cmIntegrated}` : ''));
                const linkTroya = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&es_troya=1&e="+props.email+(window.g && window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g && window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : ""+(cmIntegrated && cmIntegrated !== '' ? `&cm_integrated=${cmIntegrated}` : ''));
                if(window.opener){
                    window.opener.location.href = props.esTroya || esSiro == 'true' ? linkTroya : link;
                    if (window.opener.progressWindow){
                        window.opener.progressWindow.close();
                    }
                    window.close();   
                } else {
                    window.location.href = props.esTroya || esSiro == 'true' ? linkTroya : link;	
                }
            }
        }
    }

    if(loader && !props.modalOpen){
        return <div css={classes.aaLoader}><AACargando /></div>
    }
    const successRegisterContainer =
        <Container component="main" maxWidth="xs">
            {loader ? <div css={classes.aaLoaderModal}><AACargando /></div> : null}
            {props.modalOpen && <ModalCloseIcon onClick={handleClose} />}
            <div style={loader ? {display: 'none'} : null} css={classes.paper}>
                <Grid item xs={12}>
                    <img
                        src="/imagenes/ilustracionBienvenida.svg"
                        css={classes.designerIcon}
                    />
                </Grid>
                <Typography
                    variant="h5"
                    style={{ marginBottom: "25px" }}
                    component="div"
                >
                    {anfitrion ? titleAnfitrion : titleHuesped }
                </Typography>
                {!anfitrion || createAnfitrionPublicar ?( 
                    <Typography component="div" align="center" variant="body1">
                        {subtitleHuesped}
                    </Typography>
                ): null}
                {anfitrion || createAnfitrionPublicar ?
                    <div>
                        <Button
                            fullWidth
                            onClick={props?.createAnfitrion || createAnfitrionPublicar ? publicarAnfitrion : onClickIngresarPanel}
                            variant="contained"
                            color="primary"
                            css={classes.submit2}
                        >
                            {props?.createAnfitrion || createAnfitrionPublicar ? 'Cargar alojamiento' : 'Ingresar al panel'}
                        </Button>
                        <Button
                            fullWidth
                            onClick={onClickContinuar}
                            variant="outlined"
                            color="primary"
                            size="large"
                            css={classes.submit2}
                        >
                            Continuar al sitio
                        </Button>
                    </div>
                : 
                    <Button
                        fullWidth
                        onClick={onClickContinuar}
                        size="large"
                        variant="contained"
                        color="primary"
                        css={classes.submit}
                    >
                        Continuar al sitio
                    </Button>
                }
            </div>
        </Container>

    return (
        props.modalOpen ? (<Dialog fullScreen={isMobile.any} css={isMobile.any ? classes.modal : ''} open={props.modalOpen}>{successRegisterContainer}</Dialog>) : successRegisterContainer
    );
};
